module.exports = __webpack_public_path__ + "img/green_check.59af13b8.svg";